/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$('.selector-address-province-default').on('change',(event) => {
    getCityList(event.target.value,'default');
    let citySelect =  $('.selector-address-city-default').find(":selected").val();
    $('.input-address-city-default--hidden').val(citySelect);
});
$('.selector-address-province-new').on('change',(event) => {
    getCityList(event.target.value,'new'); 
    let idAddress = event.target.id.replace('address-','').replace('[province]','');
    let citySelect =  $('#address-'+idAddress+'-city--select').find(":selected").val();
    $('.input-address-city-new--hidden').val(citySelect);
});
$('.selector-address-province').on('change',(event) => {
    let idAddress = event.target.id.replace('address-','').replace('[province]','');
    getCityListEdit(event.target.value, idAddress);
    let citySelect =  $('#address-'+idAddress+'-city--select').find(":selected").val();
    document.getElementById('address-'+idAddress+'[city]').value = citySelect;
    
});
 $('.selector-address-city-default').on('change',(event) => {
     $('.input-address-city-default--hidden').val(event.target.value);
 });
 $('.selector-address-city-new').on('change',(event) => {
    $('.input-address-city-new--hidden').val(event.target.value);
});
$('.selector-address-city-edit').on('change',(event) => {
    let idAddress = event.target.id.replace('address-','').replace('-city--select','');
    
    document.getElementById('address-'+idAddress+'[city]').value = event.target.value;
    
});
 function getCityList(name,type) {
    $('.selector-address-city-'+type).html('<option disabled="disabled" value="---" data-provinces="[]">---</option>');
    $(allCities).map((node, item) => { 
        if(name.toLowerCase() == item.Departamento.toLowerCase()){
            item.Municipio.map((city) => { 
                $('.selector-address-city-'+type).append('<option value="'+city+'" data-provinces="[]">'+city+'</option>')
            });
        }

    });
 }
 function getCityListEdit(name, id) {
    $('#address-'+id+'-city--select').html('<option disabled="disabled" value="---" data-provinces="[]">---</option>');
    $(allCities).map((node, item) => { 
        if(name.toLowerCase() == item.Departamento.toLowerCase()){
            item.Municipio.map((city) => { 
                $('#address-'+id+'-city--select').append('<option value="'+city+'" data-provinces="[]">'+city+'</option>')
            });
        }

    });
 }
 function getProvinceList() {
    // Guard: esta función depende del formulario de direcciones de cuenta de cliente.
    // En páginas que no lo tienen (Home, PLP, PDP, etc.) no hay nada que hacer.
    if ($('.selector-address-province-default').length === 0) {
        return;
    }
    $('.selector-address-province option').each(function() {
        allCities.map((item) => { 
        if ( $(this).val() == item.Departamento ) {
            $(this).addClass('city-enable');
        }
    });
    });
    $('.selector-address-province option').each(function() {
        if(!$(this).hasClass("city-enable")){
            $(this).remove();
        }
    });
    $('.selector-address-province-default option').each(function() {
        allCities.map((item) => { 
        if ( $(this).val() == item.Departamento ) {
            $(this).addClass('city-enable');
        }
    });
    });
    $('.selector-address-province-default option').each(function() {
        if(!$(this).hasClass("city-enable")){
            $(this).remove();
        }
    });
    $('.selector-address-province-new option').each(function() {
        allCities.map((item) => { 
        if ( $(this).val() == item.Departamento ) {
            $(this).addClass('city-enable');
        }
    });
    });
    $('.selector-address-province-new option').each(function() {
        if(!$(this).hasClass("city-enable")){
            $(this).remove();
        }
    });

    let provinceName = $('.selector-address-province-default').find(":selected").val();
    let idAddress = $('.selector-address-province-default').attr('id').replace('address-','').replace('[province]','');

    getCityList(provinceName,'default');

    getCityList(allCities[0].Departamento,'new');
    $('.input-address-city-new--hidden').val(allCities[0].Municipio[0]);

    let inputCity = $('.input-address-city-default--hidden').val();
    $('.selector-address-city-default option:contains('+inputCity+')').attr('selected', 'selected');

    $('.selector-address-province').each(function() {
        let idAddress = $(this).attr('id').replace('address-','').replace('[province]','');
        inputCity = document.getElementById('address-'+idAddress+'[city]').getAttribute("value");
        let inputProvince = document.getElementById('address-'+idAddress+'[province]').getAttribute("data-default");
        if(inputProvince == "Bogotá, D.C."){
            inputProvince = "Bogotá";
            $(this).find('option:contains('+inputProvince+')').attr('selected', 'selected');
        }
        provinceName = $(this).find('option:selected').val();
        getCityListEdit(provinceName, idAddress);
        $('#address-'+idAddress+'-city--select option:contains('+inputCity+')').attr('selected', 'selected');
        
    });
 }
 getProvinceList();
/* ---------------------------------------------------------------------------
 * Add-to-cart toast, mobile cart link and related UI behaviour.
 *
 * Ported from Warehouse 3.0.1, where this block had been appended to the end
 * of assets/theme.js. It never needed to live in the vendor bundle: it is
 * self-contained and only uses DOM events, so keeping it here means Warehouse
 * updates no longer overwrite it.
 *
 * The markup it drives (#add-to-cart-toast) is rendered from layout/theme.liquid.
 * ------------------------------------------------------------------------- */

document.addEventListener("DOMContentLoaded", function() {
  if (typeof $.fn.slick !== 'function') {
    var slickScript = document.createElement('script');
    slickScript.src = (window.themeAssets && window.themeAssets.slick) || "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js";
    slickScript.onload = function() {
      initCarousel();
    };
    document.head.appendChild(slickScript);
  } else {
    initCarousel();
  }

  function initCarousel() {
    $('.image-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      dots: true,
      arrows: false,
      adaptiveHeight: true
    });
  }
});

 document.addEventListener('DOMContentLoaded', function () {
  // Interceptar clic en botones "add-to-cart" en móvil usando delegación de eventos
  // Esto captura TODOS los botones, incluyendo los cargados dinámicamente
  document.addEventListener('click', function (e) {
    const button = e.target.closest('button[data-action="add-to-cart"]');
    if (!button) return; // No es un botón add-to-cart

    const isMobile = window.innerWidth <= 768;
    if (!isMobile) return; // Dejar que funcione normal en desktop

    e.preventDefault();
    e.stopPropagation(); // Detiene la propagación hacia el delegado del tema
    e.stopImmediatePropagation(); // Evita que otros listeners se ejecuten

    const form = button.closest('form');
    if (!form) return;
    
    const formData = new FormData(form);

fetch('/cart/add.js', {
  method: 'POST',
  body: formData,
  headers: { 'Accept': 'application/json' }
})
.then(res => res.json())
.then(data => {
  showCartToast(data.product_title); // Solo nombre del producto

  // ✅ Actualizar contador del carrito en el header
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const countEl = document.querySelector('.header__cart-count');
      if (countEl) {
        countEl.textContent = cart.item_count;

        // Opcional: animación visual
        countEl.classList.add('cart-count-updated');
        setTimeout(() => countEl.classList.remove('cart-count-updated'), 300);
      }
    });

  // Cerrar mini-cart si está abierto
  document.querySelector('.mini-cart')?.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('js-drawer-open');
  document.documentElement.classList.remove('drawer-open');
})
.catch(err => {
  console.error('Error al añadir al carrito:', err);
});
  });

  // Forzar ocultar mini-cart si se abre accidentalmente en mÃ³vil
  if (window.innerWidth <= 768) {
    const observer = new MutationObserver(() => {
      const miniCart = document.querySelector('.mini-cart');
      if (miniCart?.getAttribute('aria-hidden') === 'false') {
        miniCart.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('js-drawer-open');
        document.documentElement.classList.remove('drawer-open');
      }
    });

    if (window.innerWidth > 768) {
  const countEl = document.querySelector('.header__cart-count');
  if (countEl) {
    countEl.textContent = cart.item_count;

    // Animación visual
    countEl.classList.add('cart-count-updated');
    setTimeout(() => countEl.classList.remove('cart-count-updated'), 300);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth <= 768) {
    const cartLink = document.querySelector('.header__cart-toggle');
    if (cartLink) {
      cartLink.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.href = '/cart';
      });
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const cartLink = document.querySelector('.header__cart-toggle');

  if (window.innerWidth <= 768 && cartLink) {
    cartLink.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.href = '/cart';
    });
  }
});

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    document.addEventListener('cart:updated', () => {
      const miniCart = document.querySelector('.mini-cart');
      if (miniCart) {
        miniCart.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('js-drawer-open');
        document.documentElement.classList.remove('drawer-open');
      }
    });
  }

  // Interceptar llamada a openMiniCart para bloquear en mÃ³vil
  const originalOpenMiniCart = window.openMiniCart || function () {};
  window.openMiniCart = function () {
    if (window.innerWidth > 768) {
      originalOpenMiniCart();
    }
  };
});

// Mostrar notificaciÃ³n (solo nombre del producto)
function showCartToast(productTitle) {
  if (window.innerWidth > 768) return; // Solo mobile

  const toast = document.getElementById('add-to-cart-toast');
  const message = document.getElementById('cart-toast-message');

  if (!toast || !message) return;

  message.textContent = `Se agregó ${productTitle} a tu bolsa`;
  toast.style.display = 'flex';

  setTimeout(() => {
    toast.style.display = 'none';
  }, 5000);
}


function hideCartToast() {
  const toast = document.getElementById('add-to-cart-toast');
  if (toast) toast.style.display = 'none';
}


